import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const CurrentTimezone = () => {
  const ianaTimezone = dayjs.tz.guess();

  return <span className="whitespace-nowrap">{ianaTimezone}</span>;
};

export default CurrentTimezone;
